module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/VG0003-fc29eb6fa500aafe8e29caa96c0d05e2.png";